import React from 'react';
import ParentPortfolioFilter from '../../../change-impact-report-filters/ParentPortfolioFilter.jsx';
import PortfolioFilter from '../../../change-impact-report-filters/PortfolioFilter.jsx';
import TaskOwnerFilter from '../../../change-impact-report-filters/TaskOwnerFilter.jsx';
import { getOrgTermsContent } from '../../../../content/utils.js';
import ProjectIcon from '../../../icons/ProjectIcon.jsx';
import ProjectsFilter from '../../../change-impact-report-filters/ProjectsFilter.jsx';
import Filters from '../../../filters/index.jsx';
import { navigateToChangeImpactReports } from '../../../links/index.jsx';
import { PieOutlinedIcon } from '../../../icons/PieOutlinedIcon.jsx';
import DateRangeFilter from '../../../change-impact-report-filters/DateRangeFilter.jsx';
import OwnersFilter from '../../../change-impact-report-filters/OwnersFilter.jsx';
import TitleFilter from '../../../change-impact-report-filters/TitleFilter.jsx';
import ImpactTypeFilter from '../../../change-impact-report-filters/ImpactTypeFilter.jsx';
import ScaleFilter from '../../../change-impact-report-filters/ScaleFilter.jsx';
import PerceptionFilter from '../../../change-impact-report-filters/PerceptionFilter.jsx';
import NumberOfPeopleFilter from '../../../change-impact-report-filters/NumberOfPeopleFilter.jsx';
import ActionPlanStatusFilter from '../../../change-impact-report-filters/ActionPlanStatusFilter.jsx';
import ActionPlanTypeFilter from '../../../change-impact-report-filters/ActionPlanTypeFilter.jsx';
import TaskFilter from '../../../change-impact-report-filters/TaskFilter.jsx';
import TaskStatusFilter from '../../../change-impact-report-filters/TaskStatusFilter.jsx';
import { ParticipantsIcon } from '../../../icons/ParticipantsIcon.jsx';
import GroupsFilter from '../../../change-impact-report-filters/GroupsFilter.jsx';
import EmployeesFilter from '../../../change-impact-report-filters/EmployeesFilter.jsx';
import ExternalEntitiesFilter from '../../../change-impact-report-filters/ExternalEntitiesFilter.jsx';
import StakeholdersFilter from '../../../change-impact-report-filters/StakeholdersFilter.jsx';
import { isAuthorized } from '../../../AuthorizedAction.js';
import { resetFilters } from '../utils/index.js';

function ReportFilters({
  query,
  resetDependencies,
  permissions,
  organizationId,
  hasParentPortfolios,
}) {
  const filtersData = [
    {
      key: 'project',
      title: getOrgTermsContent('project'),
      icon: <ProjectIcon />,
      filters: [
        {
          key: 'parent-portfolio',
          title: getOrgTermsContent('parentPortfolio'),
          resetQueryParams: { parentPortfolioIds: [] },
          hidden: !hasParentPortfolios,
          component: (
            <ParentPortfolioFilter
              selectedParentPortfolioIds={query.parentPortfolioIds}
            />
          ),
        },
        {
          key: 'portfolio',
          title: getOrgTermsContent('portfolio'),
          resetQueryParams: { portfolioIds: [] },
          component: (
            <PortfolioFilter selectedPortfolioIds={query.portfolioIds} />
          ),
        },
        {
          key: 'project',
          title: getOrgTermsContent('project'),
          resetQueryParams: { projectsIds: [] },
          component: (
            <ProjectsFilter
              navigateAction={navigateToChangeImpactReports}
              selectedProjectsIds={query.projectsIds}
            />
          ),
        },
      ],
    },
    {
      key: 'change-impact',
      title: 'Change Impact',
      icon: <PieOutlinedIcon />,
      preselectedFilterKeys:
        resetDependencies[0] === 'heat' ? ['date-range'] : null,
      filters: [
        {
          key: 'date-range',
          title: 'Change Impact Date Range',
          resetQueryParams: { startDate: null, endDate: null },
          component: (
            <DateRangeFilter
              type="project"
              startDate={query.startDate}
              endDate={query.endDate}
              navigateAction={navigateToChangeImpactReports}
            />
          ),
        },
        {
          key: 'owner',
          title: 'Change Impact Owner',
          resetQueryParams: { ownerIds: [] },
          component: (
            <OwnersFilter
              id={organizationId}
              navigateAction={navigateToChangeImpactReports}
              selectedOwnerIds={query.ownerIds}
            />
          ),
        },
        {
          key: 'title',
          title: 'Change Impact Title',
          resetQueryParams: { title: [] },
          component: (
            <TitleFilter
              title={query.title}
              navigateAction={navigateToChangeImpactReports}
            />
          ),
        },
        {
          key: 'impact-type',
          title: 'Impact Type',
          resetQueryParams: { changeImpactTypeIds: [] },
          component: (
            <ImpactTypeFilter
              navigateAction={navigateToChangeImpactReports}
              selectedImpactTypes={query.changeImpactTypeIds}
            />
          ),
        },
        {
          key: 'scale',
          title: 'Scale',
          resetQueryParams: { scale: [] },
          component: (
            <ScaleFilter
              navigateAction={navigateToChangeImpactReports}
              selectedScale={query.scale}
            />
          ),
        },
        {
          key: 'perception',
          title: 'Perception',
          resetQueryParams: { perceptions: [] },
          component: (
            <PerceptionFilter
              navigateAction={navigateToChangeImpactReports}
              selectedPerceptions={query.perceptions}
            />
          ),
        },
        {
          key: 'number-of-people',
          title: 'Number of People Impacted',
          resetQueryParams: { peopleImpacted: null },
          component: (
            <NumberOfPeopleFilter
              navigateAction={navigateToChangeImpactReports}
              peopleImpacted={query.peopleImpacted}
            />
          ),
        },
        {
          key: 'plan-status',
          title: 'Action Plan Status',
          resetQueryParams: { actionPlanStatuses: [] },
          component: (
            <ActionPlanStatusFilter
              navigateAction={navigateToChangeImpactReports}
              selectedPlanStatuses={query.actionPlanStatuses}
            />
          ),
        },
        {
          key: 'plan-type',
          title: 'Action Plan Type',
          resetQueryParams: { actionPlanTypes: [] },
          component: (
            <ActionPlanTypeFilter
              navigateAction={navigateToChangeImpactReports}
              selectedActionPlanTypes={query.actionPlanTypes}
            />
          ),
        },
        {
          key: 'tasks-title',
          title: 'Task Title',
          resetQueryParams: { taskIds: [] },
          component: (
            <TaskFilter
              id={organizationId}
              navigateAction={navigateToChangeImpactReports}
              selectedTaskIds={query.taskIds}
            />
          ),
        },
        {
          key: 'task-status',
          title: 'Task Status',
          resetQueryParams: { taskStatuses: [] },
          component: (
            <TaskStatusFilter
              navigateAction={navigateToChangeImpactReports}
              selectedTaskStatuses={query.taskStatuses}
            />
          ),
        },
        {
          key: 'task-owner',
          title: 'Task Owner',
          resetQueryParams: { taskOwnerIds: [] },
          component: (
            <TaskOwnerFilter
              id={organizationId}
              navigateAction={navigateToChangeImpactReports}
              selectedTaskOwnerIds={query.taskOwnerIds}
            />
          ),
        },
      ],
    },

    {
      key: 'who-is-impacted',
      title: 'Who is Impacted',
      icon: <ParticipantsIcon />,
      filters: [
        {
          key: 'impacted-groups',
          title: 'Group, Team, Department Impacted',
          resetQueryParams: { impactedGroupsIds: [] },
          component: (
            <GroupsFilter
              id={organizationId}
              navigateAction={navigateToChangeImpactReports}
              selectedGroupsIds={query.impactedGroupsIds}
            />
          ),
        },
        {
          key: 'people-impacted',
          title: 'People Impacted',
          resetQueryParams: { impactedEmployeesIds: [] },
          component: (
            <EmployeesFilter
              id={organizationId}
              selectedEmployeesIds={query.impactedEmployeesIds}
              navigateAction={navigateToChangeImpactReports}
            />
          ),
        },
        {
          key: 'external-impacted',
          title: 'External People, Group, Company, Vendor',
          resetQueryParams: { impactedExternalEntitiesIds: [] },
          component: (
            <ExternalEntitiesFilter
              id={organizationId}
              navigateAction={navigateToChangeImpactReports}
              selectedImpactedExternalEntitiesIds={
                query.impactedExternalEntitiesIds
              }
            />
          ),
        },
        {
          key: 'org-stakeholder',
          title: 'Stakeholder Group / Individual',
          disabled: !isAuthorized(
            'read',
            'organizationStakeholder',
            permissions
          ),
          resetQueryParams: { organizationStakeholderIds: [] },
          component: (
            <StakeholdersFilter
              id={organizationId}
              navigateAction={navigateToChangeImpactReports}
              selectedStakeholdersIds={query.organizationStakeholderIds}
            />
          ),
        },
      ],
    },
  ];

  return (
    <Filters
      filtersData={filtersData}
      query={query}
      resetDependencies={resetDependencies}
      resetAction={navigateToChangeImpactReports}
      resetAllAction={resetFilters}
    />
  );
}

export default ReportFilters;
